
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const team = [
  {
    name: 'Sarah Johnson',
    role: 'Chief Executive Officer',
    image: 'https://public.readdy.ai/ai/img_res/697e66e7037517e246e1ad32898f611a.jpg',
    linkedin: '#',
    quote: '20+ years leading digital transformation initiatives across global enterprises.',
  },
  {
    name: 'Michael Chen',
    role: 'Chief Technology Officer',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20Asian%20technology%20executive%20portrait%20wearing%20smart%20casual%20dark%20shirt%2C%20warm%20studio%20lighting%20with%20soft%20gradient%20background%20in%20warm%20beige%20tones%2C%20high-end%20corporate%20headshot%20photography%2C%20confident%20and%20approachable%20expression%2C%20sharp%20focus%20on%20face%2C%20modern%20tech%20leader%20look&width=400&height=480&seq=about-team-cto-new-001&orientation=portrait',
    linkedin: '#',
    quote: 'Architect of our AI and cloud platforms, with 15+ years in enterprise systems.',
  },
  {
    name: 'Emily Rodriguez',
    role: 'Chief Operations Officer',
    image: 'https://readdy.ai/api/search-image?query=Professional%20female%20Latina%20operations%20executive%20portrait%20in%20sophisticated%20navy%20blouse%2C%20warm%20studio%20lighting%20with%20soft%20gradient%20background%20in%20warm%20beige%20tones%2C%20high-end%20corporate%20headshot%20photography%2C%20poised%20and%20strategic%20expression%2C%20sharp%20focus%20on%20face%2C%20modern%20executive%20look&width=400&height=480&seq=about-team-coo-new-001&orientation=portrait',
    linkedin: '#',
    quote: 'Driving operational excellence and scaling delivery across 12 global offices.',
  },
  {
    name: 'David Park',
    role: 'Chief Innovation Officer',
    image: 'https://readdy.ai/api/search-image?query=Professional%20male%20Korean%20innovation%20executive%20portrait%20wearing%20contemporary%20dark%20turtleneck%2C%20warm%20studio%20lighting%20with%20soft%20gradient%20background%20in%20warm%20beige%20tones%2C%20high-end%20corporate%20headshot%20photography%2C%20creative%20and%20visionary%20expression%2C%20sharp%20focus%20on%20face%2C%20modern%20innovator%20look&width=400&height=480&seq=about-team-cio-new-001&orientation=portrait',
    linkedin: '#',
    quote: 'Pioneering next-gen solutions in AI, blockchain, and quantum computing.',
  },
];

export default function Team() {
  const header = useScrollAnimation();
  const grid = useScrollAnimation({ rootMargin: '0px 0px -40px 0px' });

  const delayClasses = [
    'animation-delay-100',
    'animation-delay-200',
    'animation-delay-300',
    'animation-delay-400',
  ];

  return (
    <section className="py-28 px-8 bg-white">
      <div className="max-w-[1400px] mx-auto">
        <div
          ref={header.ref}
          className={`text-center mb-20 transition-all duration-700 ${
            header.isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          <span className="text-xs font-semibold text-[#0066CC] uppercase tracking-[0.2em] mb-4 block">Leadership</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#1A2332] mb-4">The People Behind TechVision</h2>
          <p className="text-base text-gray-600 max-w-xl mx-auto">
            Seasoned leaders with decades of combined experience driving innovation at the world&apos;s top technology companies.
          </p>
        </div>

        <div ref={grid.ref} className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <div
              key={index}
              className={`group cursor-pointer ${
                grid.isVisible
                  ? `animate-fade-in-up ${delayClasses[index]}`
                  : 'opacity-0-start'
              }`}
            >
              <div className="relative overflow-hidden rounded-2xl mb-5">
                <div className="w-full h-[320px] bg-[#F5F1E8]">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-[#1A2332]/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 flex items-end p-5">
                  <p className="text-sm text-white/90 leading-relaxed">{member.quote}</p>
                </div>
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="text-base font-bold text-[#1A2332]">{member.name}</h3>
                  <p className="text-sm text-gray-500 mt-1">{member.role}</p>
                </div>
                <a
                  href={member.linkedin}
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 rounded-full bg-[#F5F5F5] flex items-center justify-center hover:bg-[#0066CC] hover:text-white text-gray-400 transition-all duration-300"
                >
                  <i className="ri-linkedin-fill text-sm"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
